import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { AuthenticationFlowPageProps } from '../AuthenticationFlow';
import { AuthenticationPasswordInput } from './AuthenticationPasswordInput';
import { LoadingButton } from 'src/components/buttons/LoadingButton';
import { useAuthSubmit } from 'src/hooks/useAuthSubmit';
import { useActionHandler } from 'src/hooks/useActionHandler';

export type AuthenticationResetPasswordPageProps =
  AuthenticationFlowPageProps & {
    closeModal: () => void;
  };

export function AuthenticationResetPasswordPage({
  pageId: pageID,
  onPageComplete,
  closeModal,
}: AuthenticationResetPasswordPageProps) {
  const { userCredentials, setUserCredentials, attemptSubmit } =
    useAuthSubmit();

  const { resetPassword } = useActionHandler();

  if (!pageID || !onPageComplete) {
    return null;
  }

  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const onSubmit = async () => {
    await resetPassword(userCredentials.password);
    onPageComplete(pageID, 'reset password success');
  };

  return (
    <Stack spacing={'32px'} mb={'64px'} width={'100%'} maxWidth={'420px'}>
      <Stack spacing={'8px'}>
        <Typography
          variant="h4"
          fontWeight="500"
          textTransform={'capitalize'}
          textAlign={'center'}
        >
          Reset Password
        </Typography>
        <Typography variant="body1" textAlign={'center'}>
          Please enter new password below.
        </Typography>
      </Stack>
      <AuthenticationPasswordInput
        onSubmit={onSubmit}
        setUserCredentials={setUserCredentials}
      />
      <Stack textAlign={'center'} direction="row" spacing="8px">
        <LoadingButton
          variant="contained"
          size="large"
          fullWidth
          onClick={async () => {
            await attemptSubmit({
              onSubmit,
              userCredentialsUpdated: userCredentials,
              requireBothInputs: false,
            });
          }}
        >
          Reset Password
        </LoadingButton>
        <Button
          variant="contained"
          size="large"
          fullWidth
          color="error"
          onClick={closeModal}
        >
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
}
